export default {"src":"/_next/static/media/BRL.b07fc8c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};